require('./stepsView.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ actions
const RASuitabilityTestWizardActions = require('actions/RASuitabilityTestWizardActions');
const formActions = require('react-redux-form').actions;
const RASuitabilityTest = require('actions/RASuitabilityTest');
// @ components
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
const RAVerticalSliderStep = require('../../RAVerticalSliderStep/RAVerticalSliderStep');
const RAModal = require('components/RAComponents/commons/RAModal/RAModal');
// @ utilities
import { formatText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
// @ constants
const { PATH_GBI_TI, PATH_ROBO_TI } = require('constants/uTagConstants/paths');
const { SUITABILITY_TEST_PROFILE_MODEL_ANSWERS, SUITABILITY_TEST_STEP_7 } = require('constants/RAConstants');
const {
    TEST_PROCESS_STEP_STEP_7,
    EVENT_CATEGORY_SUITABILITY_TEST,
    EVENT_DETAIL_MODAL_STEP_7,
    EVENT_DETAIL_MODAL_OPEN_DEFAULT,
    EVENT_DETAIL_RECONSIDER_BUTTON,
    EVENT_DETAIL_BUTTON_CLOSE,
    EVENT_DETAIL_VERIFY_MODAL,
    EVENT_DETAIL_VERIFY,
    EVENT_DETAIL_CLICK_INPUT,
    EVENT_DETAIL_TOOLTIP,
    EVENT_DETAIL_BUTTON_NEXT,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_DETAIL_QUESTION_LOAD,
} = require('constants/uTagConstants/RAConstants');
const { ROBO } = require('constants/userProfile');
const iconVerification = require('assets/icons/icono_verificacion_respuesta.svg');

class RAAbilityToTakeOnLossStepComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.onHandleContinueButton = this.onHandleContinueButton.bind(this);
        this.onHandlePrevButton = this.onHandlePrevButton.bind(this);
        this.onSliderValueChange = this.onSliderValueChange.bind(this);
        this.onVolatilityInputValueChange = this.onVolatilityInputValueChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_7,
            EVENT_DETAIL_QUESTION_LOAD,
            userProfile
        );
    }

    onHandleContinueButton() {
        const { RATestWizard, immSuitabilityTest, raSuitabilityTestWizardActions, userProfile } = this.props;
        const step = RATestWizard.currentStep;
        const substep = RATestWizard.currentSubStep;
        const { lastSubStep } = RATestWizard;
        const finalized = RATestWizard.steps?.[step].steps?.[substep].finished;
        const data = {
            step,
            substep,
        };
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        if (immSuitabilityTest.getIn(['coherenceError', 'allowToPass']) && this.hasSelectedOption()) {
            if (finalized) {
                raSuitabilityTestWizardActions.nextStep(data);
            } else if (lastSubStep) {
                raSuitabilityTestWizardActions.finishStep(data);
            } else {
                raSuitabilityTestWizardActions.finishSubStep(data);
            }

            UtagHelper.recordEventRoboGBI(
                pathForTag,
                EVENT_CATEGORY_SUITABILITY_TEST,
                TEST_PROCESS_STEP_STEP_7,
                `${EVENT_DETAIL_BUTTON_NEXT}, ${this.props.immSuitabilityTest.getIn(['answers', '219'])}`,
                userProfile
            );
        } else {
            UtagHelper.recordEventRoboGBI(
                pathForTag,
                EVENT_CATEGORY_SUITABILITY_TEST,
                TEST_PROCESS_STEP_STEP_7,
                EVENT_DETAIL_MODAL_OPEN_DEFAULT,
                userProfile
            );
            this.setState({ showModal: true });
        }
    }

    onHandlePrevButton() {
        const { RATestWizard, raSuitabilityTestWizardActions, userProfile } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const data = {
            currentStep,
            currentSubStep,
        };

        raSuitabilityTestWizardActions.prevStep(data);

        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_7,
            EVENT_DETAIL_BUTTON_PREV,
            userProfile
        );
    }

    onSliderValueChange(value) {
        const { formActions, RATestWizard, raSuitabilityTest } = this.props;
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionId = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        this.recordEventSliderClick(value);
        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.${questionId}`, value);
        raSuitabilityTest.updateVolatilityValue(value);
        raSuitabilityTest.validateStep(SUITABILITY_TEST_STEP_7);
    }

    onVolatilityInputValueChange(value) {
        const { formActions, raSuitabilityTest } = this.props;

        formActions.change(`${SUITABILITY_TEST_PROFILE_MODEL_ANSWERS}.701`, value);
        raSuitabilityTest.updateVolatilityInputValue(value);
    }

    hasSelectedOption() {
        return this.props.immSuitabilityTest.getIn(['answers', '219']) > 0;
    }

    recordEventInputClick = () => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_7,
            EVENT_DETAIL_CLICK_INPUT,
            userProfile
        );
    };

    recordEventSliderClick = value => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;
        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_7,
            value,
            userProfile
        );
    };

    recordEventTooltipClick = () => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        UtagHelper.recordEventRoboGBI(
            pathForTag,
            EVENT_CATEGORY_SUITABILITY_TEST,
            TEST_PROCESS_STEP_STEP_7,
            EVENT_DETAIL_TOOLTIP,
            userProfile
        );
    };

    toggleModal() {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }));
    }

    getModal() {
        const { immSuitabilityTest, raSuitabilityTestWizardActions, RATestWizard, userProfile } = this.props;
        const modalProps = {
            show: this.state.showModal,
        };
        const message = immSuitabilityTest.getIn(['coherenceError', 'message']);
        let modal;
        const step = RATestWizard.currentStep;
        const substep = RATestWizard.currentSubStep;
        const data = {
            step,
            substep,
        };
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_TI : PATH_GBI_TI;

        if (!this.hasSelectedOption()) {
            modalProps.title = formatText('raModal-abilityToTakeOnLossTitle');
            modalProps.text = formatText('raModal-abilityToTakeOnLossModal');
            modalProps.firstButton = formatText('raModal-continueButton');
            // Pass with warnings
            modalProps.firstAction = () => {
                UtagHelper.recordEventRoboGBI(
                    pathForTag,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    TEST_PROCESS_STEP_STEP_7,
                    `${EVENT_DETAIL_MODAL_STEP_7} ${EVENT_DETAIL_BUTTON_NEXT}`,
                    userProfile
                );

                raSuitabilityTestWizardActions.nextStep({
                    step: 2,
                    substep: 0,
                });
                raSuitabilityTestWizardActions.finishStep(data);
            };

            modalProps.secondButton = formatText('raModal-reconsiderButton');
            modalProps.secondAction = () => {
                UtagHelper.recordEventRoboGBI(
                    pathForTag,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    TEST_PROCESS_STEP_STEP_7,
                    `${EVENT_DETAIL_MODAL_STEP_7} ${EVENT_DETAIL_RECONSIDER_BUTTON}`,
                    userProfile
                );
                this.toggleModal();
            };

            modalProps.hide = () => {
                UtagHelper.recordEventRoboGBI(
                    pathForTag,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    TEST_PROCESS_STEP_STEP_7,
                    `${EVENT_DETAIL_MODAL_STEP_7} ${EVENT_DETAIL_BUTTON_CLOSE}`,
                    userProfile
                );
                this.toggleModal();
            };

            modal = <RAModal {...modalProps} />;
        } else if (message) {
            modalProps.logo = iconVerification;
            modalProps.title = formatText('raModal-title');
            modalProps.text = message;
            modalProps.firstButton = formatText('raModal-verifyButton');
            modalProps.firstAction = () => {
                UtagHelper.recordEventRoboGBI(
                    pathForTag,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    TEST_PROCESS_STEP_STEP_7,
                    `${EVENT_DETAIL_VERIFY_MODAL} ${EVENT_DETAIL_VERIFY}`,
                    userProfile
                );
                this.toggleModal();
            };
            modalProps.hide = () => {
                UtagHelper.recordEventRoboGBI(
                    pathForTag,
                    EVENT_CATEGORY_SUITABILITY_TEST,
                    TEST_PROCESS_STEP_STEP_7,
                    `${EVENT_DETAIL_VERIFY_MODAL} ${EVENT_DETAIL_BUTTON_CLOSE}`,
                    userProfile
                );
                this.toggleModal();
            };

            modal = <RAModal {...modalProps} />;
        }

        return modal;
    }

    getContent() {
        const { immSuitabilityTest } = this.props;
        const immAnswers = immSuitabilityTest.get('answers');
        const immQuestions = immSuitabilityTest.get('questions');
        const volatilityTitle = immQuestions.getIn(['219', 'title']);
        const volatilitySubtitle = immQuestions.getIn(['219', 'subtitle']);
        const volatilityValue = immAnswers.get('219');
        const volatilityAmount = immAnswers.get('701');

        return (
            <RAVerticalSliderStep
                amount={volatilityAmount}
                changeSliderValue={this.onSliderValueChange}
                disabled={false}
                subtitle={volatilitySubtitle}
                title={volatilityTitle}
                sliderValue={volatilityValue}
                updateVolatilityInputValue={this.onVolatilityInputValueChange}
                recordEventTooltipClick={this.recordEventTooltipClick}
                recordEventInputClick={this.recordEventInputClick}
            />
        );
    }

    render() {
        const { RATestWizard, userProfile } = this.props;
        const content = this.getContent();
        const modal = this.getModal();
        const { currentStep } = RATestWizard;
        const { currentSubStep } = RATestWizard;
        const questionID = RATestWizard.steps?.[currentStep].steps?.[currentSubStep].question;
        const disabled = !userProfile.RASuitabilityTest.answers[questionID];

        return (
            <div>
                <div className="steps-view">
                    {content}
                    {modal}
                </div>
                <hr />
                <div className="steps-view__footer">
                    <RoadmapNavigation
                        buttonContinueType="submit"
                        buttonContinueAction={this.onHandleContinueButton}
                        buttonContinueText={formatText('suitabilityTest-next')}
                        buttonPrevText={formatText('suitabilityTest-prev')}
                        buttonCancelText={formatText('suitabilityTest-getOut')}
                        buttonPrevAction={this.onHandlePrevButton}
                        buttonContinueDisabled={disabled}
                    />
                </div>
            </div>
        );
    }
}

export const RAAbilityToTakeOnLossStep = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        products: state.products,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        raSuitabilityTestWizardActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
    })
)(RAAbilityToTakeOnLossStepComponent);
